import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, makeStyles } from '@material-ui/core';
import NoData from './NoData';

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
}));
const NoInfo = () => {
  const { t: tGlobal } = useTranslation("global");
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <NoData />
      <Typography variant="h6" color="textPrimary">
        {tGlobal("no_data_found")}
      </Typography>
    </div>
  );
};

export default NoInfo;
